routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.login', {
      url: "login",
      template: `<login sh-ctrl="shCtrl"></login>`
    })
    .state('home.revoveryPassword', {
        url: "login",
        template: `<login r-pass="true" sh-ctrl="shCtrl"></login>`
      });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/login/login.config.js
 **/